import React, { useState } from 'react';
import Navbar from './dashboard/Navbar';
import Sidebar from './dashboard/Sidebar';
import Footer from './dashboard/Footer';

const DashboardWrapper = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="layout-page" style={{ marginLeft: window.innerWidth >= 1280 ? '256px' : 0 }}>
          <Navbar toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
          <div className="content-wrapper">
            {children}
            <Footer />
            <div className="content-backdrop fade" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardWrapper;
